import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash-es';
import { getUsedSliderPaymentsData } from 'site-modules/shared/components/car-buying/offer-type-table/offer-type-table-chart-utils';
import { InventoryEntities } from 'client/data/models/inventory';
import { PriceCheckerAnchorLink } from 'site-modules/shared/components/price-checker-anchor-link/price-checker-anchor-link';
import { PriceRatingGraphic } from 'site-modules/shared/components/price-rating-graphic/price-rating-graphic';
import { formatPriceKString } from 'site-modules/shared/utils/price-utils';

function getAriaDescription({ vehicle }) {
  const { lowerPayment, upperPayment } = getUsedSliderPaymentsData({ vehicle });
  const average = get(vehicle, 'computedDisplayInfo.priceValidation.listPriceEstimate', 0);
  const dealType = get(vehicle, 'computedDisplayInfo.priceValidation.dealType', '');

  const partOne = !dealType ? '' : `We group prices into great, good, fair, and high. This price is "${dealType}." `;
  const partTwo = !(lowerPayment && upperPayment)
    ? ''
    : `The range of prices is from ${formatPriceKString(lowerPayment)} to ${formatPriceKString(upperPayment)}. `;
  const partThree = !average ? '' : `The average price is ${formatPriceKString(average)}`;

  // notice no spaces here so that if this is the empty string it won't render the <span>
  return `${partOne}${partTwo}${partThree}`;
}

export function PriceCheckerChartPromoVdp({ vehicle = {}, isAnchorLink = false }) {
  const dealType = get(vehicle, 'computedDisplayInfo.priceValidation.dealType', '');
  const ariaDescription = getAriaDescription({ vehicle });

  return isAnchorLink ? (
    <>
      {ariaDescription && <span className="visually-hidden">{ariaDescription}</span>}
      <PriceCheckerAnchorLink type={dealType} scrollLinkClasses="text-decoration-none">
        <PriceRatingGraphic vehicle={vehicle} />
      </PriceCheckerAnchorLink>
    </>
  ) : (
    <PriceRatingGraphic vehicle={vehicle} />
  );
}

PriceCheckerChartPromoVdp.propTypes = {
  vehicle: InventoryEntities.InventoryVin,
  isAnchorLink: PropTypes.bool,
};
